import { render, staticRenderFns } from "./ExchangeDialog.vue?vue&type=template&id=3084cc26"
import script from "./ExchangeDialog.vue?vue&type=script&lang=js"
export * from "./ExchangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports